import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MantineProvider } from '@mantine/core';
import { store } from "./store/index"
import { initSentry } from './sentry.config';
import ReactGA from "react-ga4";

// Initialize Sentry using the config file
initSentry();

ReactGA.initialize("GTM-W4FQL7LH");

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <MantineProvider withGlobalClasses>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </MantineProvider>
);
